import React from "react";

// Report Components
const CancelPlotPayment = React.lazy(
  () => import("../../Accounts/Reports/CancelPlotPayment/CancelPlotPayment"),
);
const AccountReceivableAgingDetailTransaction = React.lazy(
  () =>
    import("../../Accounts/Reports/AccountReceivableAgingDetail/AccountReceivableAgingDetailTransaction"),
);
const WhatsappHistory = React.lazy(
  () => import("../../Accounts/Reports/WhatsappHistory/WhatsappHistory"),
);
const WhatsappHistoryDetails = React.lazy(
  () => import("../../Accounts/Reports/WhatsappHistory/WhatsappHistoryDetails"),
);
const PdcReceivableTable = React.lazy(
  () => import("../../Accounts/Vouchers/PDC/PdcReceivable/PdcReceivableTable"),
);
const CostCenter = React.lazy(() => import("../../Accounts/Reports/CostCenter/CostCenter"));
const AccountPayable = React.lazy(
  () => import("../../Accounts/Reports/AccountPayable/AccountPayable"),
);
const AccountReceivable = React.lazy(
  () => import("../../Accounts/Reports/AccountReceviable/AccountReceivable"),
);
const AccountReceivableAgingSummary = React.lazy(
  () =>
    import("../../Accounts/Reports/AccountReceivableAgingSummary/AccountReceivableAgingSummary"),
);
const AccountPayableAgingDetailTransaction = React.lazy(
  () =>
    import("../../Accounts/Reports/AccountPayableAgingDetail/AccountPayableAgingDetailTransaction"),
);
const AccountPayableAgingSummary = React.lazy(
  () => import("../../Accounts/Reports/AccountPayableAgingSummary/AccountPayableAgingSummary"),
);
const AdminSharePayableReport = React.lazy(
  () => import("../../Accounts/Reports/AdminSharePayable/AdminSharePayableReport"),
);
const BalanceSheet = React.lazy(() => import("../../Accounts/Reports/BalanceSheet/BalanceSheet"));
const PdcPayableTable = React.lazy(
  () => import("../../Accounts/Vouchers/PDC/PdcPayable/PdcPayableTable"),
);
const CashBook = React.lazy(() => import("../../Accounts/Reports/CashBook/CashBook"));
const BankBook = React.lazy(() => import("../../Accounts/Reports/BankBook/BankBook"));
const CommissionPayment = React.lazy(
  () => import("../../Accounts/Reports/CommissionPayment/CommissionPayment"),
);
const CommissionReceipt = React.lazy(
  () => import("../../Accounts/Reports/CommissionReceipt/CommissionReceipt"),
);
const GeneralJournalReport = React.lazy(
  () => import("../../Accounts/Reports/GeneralJournal/GeneralJournal"),
);
const GeneralLedger = React.lazy(
  () => import("../../Accounts/Reports/GeneralLedger/GeneralLedger"),
);
const IncomeStatement = React.lazy(
  () => import("../../Accounts/Reports/IncomeStatement/IncomeStatement"),
);
const InstallmentPayment = React.lazy(
  () => import("../../Accounts/Reports/InstallPayment/InstallPayment"),
);
const InstallmentReceipt = React.lazy(
  () => import("../../Accounts/Reports/InstallReceipt/InstallReceipt"),
);
const ManagerRecovery = React.lazy(
  () => import("../../Accounts/Reports/ManagerRecovery/ManagerRecovery"),
);
const ProjectReport = React.lazy(
  () => import("../../Accounts/Reports/ProjectReport/ProjectReport"),
);
const RepurchasedUnitsSummary = React.lazy(
  () => import("../../Accounts/Reports/RepurchasedUnitsSummary/RepurchasedUnitsSummary"),
);
const CashFlowDashbaord = React.lazy(() => import("../../Analytics/CashFlow/CashFlowDashbaord"));
const ProjectCostDashboard = React.lazy(
  () => import("../../Analytics/ProjectCost/ProjectCostDashboard"),
);
const SalesRecoveryDashboard = React.lazy(
  () => import("../../Analytics/SalesRecovery/SalesRecoveryDashboard"),
);
const ProfitabilityMarginsDashboard = React.lazy(
  () => import("../../Analytics/Profitability/ProfitabilityMarginsDashboard"),
);
const ExecutiveOverviewDashboard = React.lazy(
  () => import("../../Analytics/Executive/ExecutiveOverviewDashboard"),
);
const RecoveryReceiptReport = React.lazy(
  () => import("../../Accounts/Reports/RecoveryReceipt/RecoveryReceipt"),
);
const UnitsReport = React.lazy(() => import("../../Accounts/Reports/Units/Units"));
const ReserveCommissionPayableReport = React.lazy(
  () => import("../../Accounts/Reports/ReserveCommissionPayable/ReserveCommissionPayableReport"),
);
const TrailBalance = React.lazy(() => import("../../Accounts/Reports/TrailBalance/TrailBalance"));
const TaxReceivableMain = React.lazy(
  () => import("../../Accounts/Tax/TaxReceivable/TaxReceivableMain"),
);
const SubmittedVouchers = React.lazy(
  () => import("../../Accounts/Vouchers/SubmittedVouchers/SubmittedVouchers"),
);
const UnSubmittedVouchers = React.lazy(
  () => import("../../Accounts/Vouchers/UnSumbittedVouhcers/UnSubmittedVouchers"),
);
const CustomerDashboard = React.lazy(() => import("../../Accounts/Reports/Units/Customers"));
const AffiliateLeaderboardDashboard = React.lazy(
  () =>
    import("../../Accounts/Reports/AffiliateLeaderboardDashboard/AffiliateLeaderboardDashboard"),
);
const AffiliateCommissionReport = React.lazy(
  () => import("../../Accounts/Reports/AffiliateCommissionReport/AffiliateCommissionReport"),
);
// const DeletedVouchersReport = React.lazy(
//   () => import("../../Accounts/Reports/DeletedVouchers/DeletedVouchers"),
// );

// Dashboard
const AccDashboard = React.lazy(() => import("../../Accounts/DashboardPage/AccountERPDashboard"));

// Chart of Accounts
const Account = React.lazy(() => import("../../Accounts/ChartofAccount/AddAccount/AddAccount"));
const AddHeading = React.lazy(() => import("../../Accounts/ChartofAccount/AddHeading/AddHeading"));
const Banks = React.lazy(() => import("../../Accounts/ChartofAccount/Banks/Banks"));
const AddBankForm = React.lazy(() => import("../../Accounts/ChartofAccount/Banks/AddBankForm"));
const ChartofAccount = React.lazy(
  () => import("../../Accounts/ChartofAccount/ChartofAcc/ChartofAccount"),
);

// Vouchers - Receipt Entry
const GeneralReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/GeneralReceipt/GeneralReceiptTable"),
);
const UnitReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/UnitReceipt/UnitReceiptTable"),
);
const DealSoldRecTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/DealSoldRec/DealSoldRecTable"),
);
const RecoveryReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/RecoveryReceipt/RecoveryReceiptTable"),
);
const InvestReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/InvestReceipt/InvestReceiptTable"),
);
const CommissionReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/CommissionReceipt/CommissionReceiptTable"),
);

// Vouchers - Payment Entry
const GeneralPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/GeneralPayment/GeneralPaymentTable"),
);
const PurchasePaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/PurchasePayment/PurchasePaymentTable"),
);
const CommissionPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/CommissionPayment/CommissionPaymentTable"),
);
const DealPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/DealPayment/DealPaymentTable"),
);
const DeveloperPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/DeveloperPayment/DeveloperPaymentTable"),
);
const InvestPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/InvestPayment/InvestPaymentTable"),
);
const SalaryPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/SalaryPayment/SalaryPaymentTable"),
);
const LandPaymentTable = React.lazy(
  () => import("../../Accounts/PaymentEntry/LandPayment/LandPaymentTable"),
);

// Vouchers - Forms
const GeneralReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/GeneralReceipt/GeneralReceiptForm"),
);
const UnitReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/UnitReceipt/UnitReceiptForm"),
);
const RecoveryReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/RecoveryReceipt/RecoveryReceiptForm"),
);
const InvestReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/InvestReceipt/InvestReceiptForm"),
);
const CommissionReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/CommissionReceipt/CommissionReceiptForm"),
);
const GeneralPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/GeneralPayment/GeneralPaymentForm"),
);
const PurchasePaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/PurchasePayment/PurchasePaymentForm"),
);
const ClientReceiptTable = React.lazy(
  () => import("../../Accounts/ReceiptEntry/ClientReceipt/ClientReceiptTable"),
);
const ClientReceiptForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/ClientReceipt/ClientReceiptForm"),
);
const LandPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/LandPayment/LandPaymentForm"),
);
const SalaryPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/SalaryPayment/SalaryPaymentForm"),
);
const InvestPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/InvestPayment/InvestPaymentForm"),
);
const DealPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/DealPayment/DealPaymentForm"),
);
const DeveloperPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/DeveloperPayment/DeveloperPaymentForm"),
);
const CommissionPaymentForm = React.lazy(
  () => import("../../Accounts/PaymentEntry/CommissionPayment/CommissionPaymentForm"),
);
const DealSoldRecForm = React.lazy(
  () => import("../../Accounts/ReceiptEntry/DealSoldRec/DealSoldRecForm"),
);

// Vouchers - Other
const ChangeInReqMain = React.lazy(() => import("../../Accounts/ChangeInReqMain2/ChangeInReqMain"));
const RecoveryBookingForm = React.lazy(
  () => import("../../Accounts/Vouchers/RecoveryBooking/RecoveryBookingForm"),
);
const RecoveryBookingTable = React.lazy(
  () => import("../../Accounts/Vouchers/RecoveryBooking/RecoveryBookingTable"),
);
const ExternalCommissionTable = React.lazy(
  () => import("../../Accounts/Vouchers/ExternalCommission/ExternalCommissionTable"),
);
const ExternalCommissionForm = React.lazy(
  () => import("../../Accounts/Vouchers/ExternalCommission/ExternalCommissionForm"),
);
const GeneralAdjustmentForm = React.lazy(
  () => import("../../Accounts/Vouchers/GeneralAdjustment/GeneralAdjustmentForm"),
);
const JournalEntryForm = React.lazy(
  () => import("../../Accounts/Vouchers/JournalEntry/JournalEntryForm"),
);
const JournalEntryTable = React.lazy(
  () => import("../../Accounts/Vouchers/JournalEntry/JournalEntryTable"),
);
const GeneralAdjTable = React.lazy(
  () => import("../../Accounts/Vouchers/GeneralAdjustment/GeneralAdjustmentTable"),
);
const ReceiptInstallmentsTable = React.lazy(
  () => import("../../Accounts/Vouchers/Installments/ReceiptInstallment/ReceiptInstallmentsTable"),
);
const PaymentInstallmentsTable = React.lazy(
  () => import("../../Accounts/Vouchers/Installments/PaymentInstallment/PaymentInstallemnetTable"),
);
const ReceiptInstallmentsForm = React.lazy(
  () => import("../../Accounts/Vouchers/Installments/ReceiptInstallment/ReceiptInstallmentsForm"),
);
const PaymentInstallmentForm = React.lazy(
  () => import("../../Accounts/Vouchers/Installments/PaymentInstallment/PaymentInstallmentForm"),
);
const RefundPaymentTable = React.lazy(
  () => import("../../Accounts/Vouchers/RefundPayment/RefundPaymentTable"),
);
const RefundPaymentForm = React.lazy(
  () => import("../../Accounts/Vouchers/RefundPayment/RefundPaymentForm"),
);
const RevertBackVouchers = React.lazy(
  () => import("../../Accounts/Vouchers/RevertBackVouchers/RevertBackVouchers"),
);

// Contracts
const ContractERPDashboard = React.lazy(() => import("../../Contract/ContractERPDashboard"));
const ContractTable = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractTable"));
const ContractForm = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractForm"));
const ContractForm2 = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractForm2"));
const PaymentPlanScreen = React.lazy(
  () => import("../../Accounts/Contracts/PaymentPlan/PaymentPlanScreen"),
);
const CustomerTable = React.lazy(() => import("../../Accounts/Contracts/Customer/CustomerTable"));
const AddCustomerForm = React.lazy(() => import("../../Accounts/Contracts/Customer/CustomerForm"));
const InstallResceduleTable = React.lazy(
  () => import("../../Accounts/Contracts/InstallmentRescedule/InstallResceduleTable"),
);
const InstallResceduleform = React.lazy(
  () => import("../../Accounts/Contracts/InstallmentRescedule/InstallResceduleForm"),
);
const TransferContractTable = React.lazy(
  () => import("../../Accounts/Contracts/TransferContract/TransferContractTable"),
);
const TransferContractPage = React.lazy(
  () => import("../../Accounts/Contracts/TransferContract/TransferContractForm"),
);
const TransferUnitTable = React.lazy(
  () => import("../../Accounts/Contracts/TransferUnit/TransferUnitTable"),
);
const TransferUnitPage = React.lazy(
  () => import("../../Accounts/Contracts/TransferUnit/TransferUnitForm"),
);
const BallotTable = React.lazy(() => import("../../Accounts/Contracts/Ballot/BallotTable"));
const BallotForm = React.lazy(() => import("../../Accounts/Contracts/Ballot/BallotForm"));

// Tax
const TaxTable = React.lazy(() => import("../../Accounts/Tax/Tax/TaxTable"));
const TaxPayableTable = React.lazy(() => import("../../Accounts/Tax/TaxPayable/TaxPayableTable"));
const TaxForm = React.lazy(() => import("../../Accounts/Tax/Tax/TaxForm"));
const TaxPaybleForm = React.lazy(() => import("../../Accounts/Tax/TaxPayable/TaxPayableForm"));
const TaxReceivableForm = React.lazy(
  () => import("../../Accounts/Tax/TaxReceivable/TaxReceivableForm"),
);

// Investment
const InvestorTable = React.lazy(() => import("../../Accounts/Investments/Investor/InvestorTable"));
const AddInvestor = React.lazy(() => import("../../Accounts/Investments/Investor/AddInvestor"));
const InvestmentTable = React.lazy(
  () => import("../../Accounts/Investments/Investment/InvestmentTable"),
);
const Investment = React.lazy(() => import("../../Accounts/Investments/Investment/Investment"));

// Tags
const TagsTable = React.lazy(() => import("../../Accounts/Tags/TagsTable"));
const AddTagsForm = React.lazy(() => import("../../Accounts/Tags/AddTagsForm"));

// Roles
const RoleAddTable = React.lazy(() => import("../../Accounts/roles/roles"));
const RoleAddForm = React.lazy(() => import("../../Accounts/roles/rolesForm"));

// Approval
const ApprovalsTable = React.lazy(() => import("../../Accounts/approval/Approvals"));

// Business Profile
const BusinessProfile = React.lazy(() => import("../../Accounts/BusinessProfile/BusinessProfile"));
const PersonalProfile = React.lazy(() => import("../../Accounts/PersonalProfile/PersonalProfile"));

// LandInstallTracker
const LandInstallTracker = React.lazy(
  () => import("../../Accounts/Reports/LandInstallmentTracker/LandInstallTracker"),
);

// Inventory imports for contracts/affiliates
const MainAffiliates = React.lazy(() => import("../../Inventory/deals/Affiliates/MainAffiliates"));
const AffiliateForm = React.lazy(() => import("../../Inventory/deals/Affiliates/AffiliateForm"));

export const accountRoutes = [
  {
    path: "/account/dashboard",
    Component: AccDashboard,
    rolename: "Accounts_Dashboard",
  },

  // Vouchers - Receipt Entry
  {
    path: "/account/vouchers/receipt-entry",
    Component: GeneralReceiptTable,
    rolename: "Vouchers_Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/general-receipt",
    Component: GeneralReceiptTable,
    rolename: "Receipt_General Receipt",
  },
  {
    path: "/account/vouchers/pdc-entry/pdc-payable",
    Component: PdcPayableTable,
    rolename: "ERP-PDC_PDC Payable",
  },
  {
    path: "/account/vouchers/pdc-entry/pdc-receivable",
    Component: PdcReceivableTable,
    rolename: "ERP-PDC_PDC Receivable",
  },
  {
    path: "/account/vouchers/receipt-entry/general-receipt/add",
    Component: GeneralReceiptForm,
    rolename: "Receipt_General Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/deal-sold-rec",
    Component: DealSoldRecTable,
    rolename: "Receipt_Deal Sold Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/deal-sold-rec/add",
    Component: DealSoldRecForm,
    rolename: "Receipt_Deal Sold Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/com-receipt",
    Component: CommissionReceiptTable,
    rolename: "Receipt_Com Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/com-receipt/add",
    Component: CommissionReceiptForm,
    rolename: "Receipt_Com Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/client-receipt",
    Component: ClientReceiptTable,
    rolename: "ERP-Receipt_Client_Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/client-receipt/add",
    Component: ClientReceiptForm,
    rolename: "ERP-Receipt_Client_Receipt",
  },

  // Vouchers - Payment Entry
  {
    path: "/account/vouchers/payment-entry",
    Component: GeneralPaymentTable,
    rolename: "Receipt_Com Receipt",
  },
  {
    path: "/account/vouchers/payment-entry/general-payment",
    Component: GeneralPaymentTable,
    rolename: "Payments_General Payment",
  },
  {
    path: "/account/vouchers/payment-entry/general-payment/add",
    Component: GeneralPaymentForm,
    rolename: "Payments_General Payment",
  },
  // Purchase Payment reuses the General Payment role strings (owner decision: no new roles).
  {
    path: "/account/vouchers/payment-entry/purchase-payment",
    Component: PurchasePaymentTable,
    rolename: "Payments_General Payment",
  },
  {
    path: "/account/vouchers/payment-entry/purchase-payment/add",
    Component: PurchasePaymentForm,
    rolename: "Payments_General Payment",
  },
  {
    path: "/account/vouchers/payment-entry/land-payment",
    Component: LandPaymentTable,
    rolename: "Payments_Land Payment",
  },
  {
    path: "/account/vouchers/payment-entry/land-payment/add",
    Component: LandPaymentForm,
    rolename: "Payments_Land Payment",
  },
  {
    path: "/account/vouchers/payment-entry/salary-payment",
    Component: SalaryPaymentTable,
    rolename: "Payments_Salary Payment",
  },
  {
    path: "/account/vouchers/payment-entry/salary-payment/add",
    Component: SalaryPaymentForm,
    rolename: "Payments_Salary Payment",
  },
  {
    path: "/account/vouchers/payment-entry/invest-payment",
    Component: InvestPaymentTable,
    rolename: "Payments_Investment Payment",
  },
  {
    path: "/account/vouchers/payment-entry/invest-payment/add",
    Component: InvestPaymentForm,
    rolename: "Payments_Investment Payment",
  },
  {
    path: "/account/vouchers/payment-entry/deal-payment",
    Component: DealPaymentTable,
    rolename: "Payments_Deal Payment",
  },
  {
    path: "/account/vouchers/payment-entry/deal-payment/add",
    Component: DealPaymentForm,
    rolename: "Payments_Deal Payment",
  },
  {
    path: "/account/vouchers/payment-entry/developer-payment",
    Component: DeveloperPaymentTable,
    rolename: "Developer Payment",
  },
  {
    path: "/account/vouchers/payment-entry/developer-payment/add",
    Component: DeveloperPaymentForm,
    rolename: "Developer Payment",
  },
  {
    path: "/account/vouchers/payment-entry/com-payment",
    Component: CommissionPaymentTable,
    rolename: "Payments_Com Payment",
  },
  {
    path: "/account/vouchers/payment-entry/com-payment/add",
    Component: CommissionPaymentForm,
    rolename: "Payments_Com Payment",
  },
  {
    path: "/account/vouchers/receipt-entry/unit-receipt",
    Component: UnitReceiptTable,
    rolename: "Receipt_Unit Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/unit-receipt/add",
    Component: UnitReceiptForm,
    rolename: "Receipt_Unit Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/recovery-receipt",
    Component: RecoveryReceiptTable,
    rolename: "Receipt_Recovery Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/recovery-receipt/add",
    Component: RecoveryReceiptForm,
    rolename: "Receipt_Recovery Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/invest-receipt",
    Component: InvestReceiptTable,
    rolename: "Receipt_Invest Receipt",
  },
  {
    path: "/account/vouchers/receipt-entry/invest-receipt/add",
    Component: InvestReceiptForm,
    rolename: "Receipt_Invest Receipt",
  },
  {
    path: "/account/vouchers/expense-voucher",
    Component: GeneralReceiptTable,
    props: { isExpense: true },
    rolename: "Vouchers_Expense",
  },
  {
    path: "/account/vouchers/expense-voucher/add",
    Component: GeneralReceiptForm,
    props: { isExpense: true },
    rolename: "Vouchers_Expense",
  },
  {
    path: "/account/vouchers/refund-voucher",
    Component: RefundPaymentTable,
    rolename: "Vouchers_Refunds",
  },
  {
    path: "/account/vouchers/refund-voucher/add",
    Component: RefundPaymentForm,
    rolename: "Vouchers_Refunds",
  },
  {
    path: "/account/vouchers/recovery-booking",
    Component: RecoveryBookingTable,
    rolename: "Recovery Booking",
  },
  {
    path: "/account/vouchers/recovery-booking/add",
    Component: RecoveryBookingForm,
    rolename: "Recovery Booking",
  },
  {
    path: "/account/vouchers/external-commission",
    Component: ExternalCommissionTable,
    props: { CommissionType: "INCOME" },
    rolename: "Vouchers_External Comm",
  },
  {
    path: "/account/vouchers/external-commission/income",
    Component: ExternalCommissionTable,
    props: { CommissionType: "INCOME" },
    rolename: "External Comm_Income",
  },
  {
    path: "/account/vouchers/external-commission/income/add",
    Component: ExternalCommissionForm,
    props: { CommissionType: "INCOME" },
    rolename: "External Comm_Income",
  },
  {
    path: "/account/vouchers/external-commission/expense/add",
    Component: ExternalCommissionForm,
    props: { CommissionType: "EXPENSE" },
    rolename: "External Comm_Expense",
  },
  {
    path: "/account/vouchers/external-commission/expense",
    Component: ExternalCommissionTable,
    props: { CommissionType: "EXPENSE" },
    rolename: "External Comm_Expense",
  },
  {
    path: "/account/vouchers/general-adjustment",
    Component: GeneralAdjTable,
    rolename: "Vouchers_Adjustments",
  },
  {
    path: "/account/vouchers/general-adjustment/add",
    Component: GeneralAdjustmentForm,
    rolename: "Vouchers_Adjustments",
  },
  {
    path: "/account/vouchers/journal-entry",
    Component: JournalEntryTable,
    rolename: "Vouchers_Journal Entry",
  },
  {
    path: "/account/vouchers/journal-entry/add",
    Component: JournalEntryForm,
    rolename: "Vouchers_Journal Entry",
  },
  {
    path: "/account/vouchers/installments",
    Component: ReceiptInstallmentsTable,
    rolename: "Vouchers_Installments",
  },
  {
    path: "/account/vouchers/installments/receipt-installments",
    Component: ReceiptInstallmentsTable,
    rolename: "Installments_Receipt Installments",
  },
  {
    path: "/account/vouchers/installments/receipt-installments/add",
    Component: ReceiptInstallmentsForm,
    rolename: "Installments_Receipt Installments",
  },
  {
    path: "/account/vouchers/installments/payment-installments",
    Component: PaymentInstallmentsTable,
    rolename: "Installments_Payment Installments",
  },
  {
    path: "/account/vouchers/installments/payment-installments/add",
    Component: PaymentInstallmentForm,
    rolename: "Installments_Payment Installments",
  },
  {
    path: "/account/vouchers/unsubmitted-vouchers",
    Component: UnSubmittedVouchers,
    rolename: "Vouchers_Draft Vouch",
  },
  {
    path: "/account/vouchers/submitted-vouchers",
    Component: SubmittedVouchers,
    rolename: "Vouchers_Saved Vouch",
  },

  // Contracts
  {
    path: "/contract/contracts/with-unit",
    Component: ContractTable,
    props: { isFile: false },
    rolename: "Contracts_Contract With Unit",
  },
  {
    path: "/contract/dashboard",
    component: <ContractERPDashboard />,
    rolename: "ERP-Contract_Dashboard",
  },
  {
    path: "/contract/contracts/without-unit",
    Component: ContractTable,
    props: { isFile: true },
    rolename: "Contracts_Contract Without Unit",
  },
  {
    path: "/contract/contracts/add-with-unit",
    Component: ContractForm,
    rolename: "Contracts_Contract With Unit",
  },
  {
    path: "/contract/contracts/add-without-unit",
    Component: ContractForm2,
    rolename: "Contracts_Contract Without Unit",
  },
  {
    path: "/contract/contracts/payment-plan",
    Component: PaymentPlanScreen,
    rolename: "ERP-Contracts_Payment Plan",
  },
  {
    path: "/contract/contracts/payment-plan",
    Component: PaymentPlanScreen,
    rolename: "Contracts_Contract With Unit",
  },
  {
    path: "/contract/customers",
    Component: CustomerTable,
    rolename: "Contract_Customers",
  },
  {
    path: "/contract/customers/add",
    Component: AddCustomerForm,
    rolename: "Contract_Customers",
  },
  {
    path: "/contract/affiliates",
    Component: MainAffiliates,
    props: { type: "AffliateTable" },
    rolename: "Contract_Affiliates",
  },
  {
    path: "/contract/affiliates/add",
    Component: AffiliateForm,
    rolename: "Contract_Affiliates",
  },
  {
    path: "/contract/install-reschedule",
    Component: InstallResceduleTable,
    rolename: "Contract_Install Resch",
  },
  {
    path: "/contract/install-reschedule/add",
    Component: InstallResceduleform,
    rolename: "Contract_Install Resch",
  },
  {
    path: "/contract/ballot",
    Component: BallotTable,
    rolename: "Contract_Ballot",
  },
  {
    path: "/contract/ballot/add",
    Component: BallotForm,
    rolename: "Ballot_Create",
  },
  {
    path: "/contract/transfer-contract",
    Component: TransferContractTable,
    rolename: "Contract_Trans Contract",
  },
  {
    path: "/contract/transfer-contract/add",
    Component: TransferContractPage,
    rolename: "Contract_Trans Contract",
  },
  {
    path: "/contract/transfer-unit",
    Component: TransferUnitTable,
    rolename: "Contract_Transfer Unit",
  },
  {
    path: "/contract/transfer-unit/add",
    Component: TransferUnitPage,
    rolename: "Contract_Transfer Unit",
  },

  // Chart of Accounts
  {
    path: "/account/chart-of-acc/Chart",
    Component: ChartofAccount,
    rolename: "Chart Of Acc_View",
  },
  // Headings are gated like accounts: this screen replaced the heading modal that
  // lived inside Account, so whoever could add a heading there can add one here.
  {
    path: "/account/chart-of-acc/heading",
    Component: AddHeading,
    rolename: "ERP-Chart Of Acc_Heading",
  },
  {
    path: "/account/chart-of-acc/account",
    Component: Account,
    rolename: "Chart Of Acc_Account",
  },
  // Banks are gated like accounts too: Add Account already creates a bank whenever an
  // account lands under a bank heading, so a separate Banks role restricted nothing.
  {
    path: "/account/chart-of-acc/banks",
    Component: Banks,
    rolename: "ERP-Chart Of Acc_Bank",
  },
  {
    path: "/account/chart-of-acc/banks/add",
    Component: AddBankForm,
    rolename: "Chart Of Acc_Account",
  },

  // Tax
  {
    path: "/account/tax/Tax",
    Component: TaxTable,
    rolename: "Tax_Tax",
  },
  {
    path: "/account/tax/Tax/add",
    Component: TaxForm,
    rolename: "Tax_Tax",
  },
  {
    path: "/account/tax/tax-payable",
    Component: TaxPayableTable,
    rolename: "Tax_Tax Payable",
  },
  {
    path: "/account/tax/tax-payable/pay",
    Component: TaxPaybleForm,
    rolename: "Tax_Tax Payable",
  },
  {
    path: "/account/tax/tax-receivable",
    Component: TaxReceivableMain,
    rolename: "Tax_Tax Receivable",
  },
  {
    path: "/account/tax/tax-receivable/pay",
    Component: TaxReceivableForm,
    rolename: "Tax_Tax Receivable",
  },

  // Investment
  {
    path: "/account/investment/Investment",
    Component: InvestmentTable,
    rolename: "Investment_Investment",
  },
  {
    path: "/account/investment/Investment/add",
    Component: Investment,
    rolename: "Investment_Investment",
  },
  {
    path: "/account/investment/Investor",
    Component: InvestorTable,
    rolename: "Investment_Investor",
  },
  {
    path: "/account/investment/Investor/add",
    Component: AddInvestor,
    rolename: "Investment_Investor",
  },

  // Reports
  {
    path: "/account/reports/trail-balance",
    Component: TrailBalance,
    rolename: "Reports_Trail Balance",
  },
  {
    path: "/account/reports/cost-center",
    Component: CostCenter,
    rolename: "Reports_Cost Center",
  },
  {
    path: "/account/reports/general-journal",
    Component: GeneralJournalReport,
    rolename: "Reports_General Journal",
  },
  {
    path: "/account/reports/general-ledger",
    Component: GeneralLedger,
    rolename: "Reports_General Ledger",
  },
  {
    path: "/account/reports/land-installment-tracker",
    Component: LandInstallTracker,
    rolename: "Reports_Land Installment Tracker",
  },
  {
    path: "/account/reports/cancelled-plots",
    Component: CancelPlotPayment,
    rolename: "Reports_Cancelled Plots",
  },
  {
    path: "/account/reports/balance-sheet",
    Component: BalanceSheet,
    rolename: "Reports_Balance Sheet",
  },
  {
    path: "/account/reports/income-statement",
    Component: IncomeStatement,
    rolename: "Reports_Income Statement",
  },
  {
    path: "/account/reports/cash-book",
    Component: CashBook,
    rolename: "Reports_Cash Book",
  },
  {
    path: "/account/reports/bank-book",
    Component: BankBook,
    rolename: "Reports_Bank Book",
  },
  {
    path: "/account/reports/manager-recovery",
    Component: ManagerRecovery,
    rolename: "Reports_Manager Recovery",
  },
  {
    path: "/account/reports/recovery-receipt",
    Component: RecoveryReceiptReport,
    rolename: "Reports_Recovery Receipt",
  },
  {
    path: "/account/reports/account-payable",
    Component: AccountPayable,
    rolename: "Reports_Account Payable",
  },
  {
    path: "/account/reports/account-receivable",
    Component: AccountReceivable,
    rolename: "Reports_Account Receivable",
  },
  {
    path: "/account/reports/account-receivable-aging-details",
    Component: AccountReceivableAgingDetailTransaction,
    rolename: "Reports_Account Receivable Aging",
  },
  {
    path: "/account/reports/account-payable-aging-details",
    Component: AccountPayableAgingDetailTransaction,
    rolename: "Reports_Account Payable Aging",
  },
  {
    path: "/account/reports/account-receivable-aging-summary",
    Component: AccountReceivableAgingSummary,
    rolename: "Reports_Account Receivable Aging Summary",
  },
  {
    path: "/account/reports/account-payable-aging-summary",
    Component: AccountPayableAgingSummary,
    rolename: "Reports_Account Payable Aging Summary",
  },
  {
    path: "/account/reports/admin-share-payable",
    Component: AdminSharePayableReport,
    rolename: "Reports_Admin Share Payable",
  },
  {
    path: "/account/reports/project-report",
    Component: ProjectReport,
    rolename: "Reports_Project Report",
  },
  {
    path: "/account/reports/install-receipt",
    Component: InstallmentReceipt,
    rolename: "Reports_Install Receipt",
  },
  {
    path: "/account/reports/install-payment",
    Component: InstallmentPayment,
    rolename: "Reports_Install Payment",
  },
  {
    path: "/account/reports/commission-payment",
    Component: CommissionPayment,
    rolename: "Reports_Commission Payment",
  },
  {
    path: "/account/reports/commission-receipt",
    Component: CommissionReceipt,
    rolename: "Reports_Commission Receipt",
  },
  {
    path: "/account/reports/reserved-commission-payable",
    Component: ReserveCommissionPayableReport,
    rolename: "Reports_Reserved Commission Payable",
  },
  {
    path: "/account/reports/repurchased-units-summary",
    Component: RepurchasedUnitsSummary,
    rolename: "Reports_Refund Summary",
  },
  {
    path: "/contract/reports/units",
    Component: UnitsReport,
    rolename: "Reports_Units",
  },
  {
    path: "/contract/reports/customer",
    Component: CustomerDashboard,
    rolename: "Reports_Customer",
  },
  {
    path: "/contract/reports/affiliate-leaderboard",
    component: <AffiliateLeaderboardDashboard />,
    rolename: "ERP-Reports_Affiliate Leaderboard",
  },
  {
    path: "/contract/reports/affiliate-commission",
    Component: AffiliateCommissionReport,
    rolename: "ERP-Reports_Affiliate Commission",
  },
  // {
  //   path: "/account/reports/deleted-vouchers",
  //   Component: DeletedVouchersReport,
  //   rolename: "Reports_Deleted Vouchers",
  // },

  // Tags
  {
    path: "/settings/tags",
    Component: TagsTable,
    rolename: "Settings_Tags",
  },
  {
    path: "/settings/tags/add",
    Component: AddTagsForm,
    rolename: "ERP-Tags_Create",
  },

  // Roles
  {
    path: "/settings/roles",
    Component: RoleAddTable,
    rolename: "Settings_Roles",
  },
  {
    path: "/settings/roles/add",
    Component: RoleAddForm,
    rolename: "Settings_Roles",
  },

  // Approval
  {
    path: "/settings/approvals",
    Component: ApprovalsTable,
    rolename: "ERP-Settings_Approvals",
  },

  // Business Profile
  {
    path: "/settings/profile/business",
    Component: BusinessProfile,
    rolename: "ERP-Profile_Business Profile",
  },
  {
    path: "/settings/profile/personal",
    Component: PersonalProfile,
    rolename: "ERP-Profile_Personal Profile",
  },

  // Change Request
  {
    path: "/settings/change-request",
    Component: ChangeInReqMain,
    rolename: "Settings_Change Request",
  },

  // Revert Back Vouchers
  {
    path: "/settings/revert-back-vouchers",
    Component: RevertBackVouchers,
    rolename: "Settings_Revert Back Vouchers",
  },

  // WhatsApp History
  {
    path: "/settings/whatsapp/wa-history",
    Component: WhatsappHistory,
    rolename: "WhatsApp_History",
  },
  {
    path: "/settings/whatsapp/wa-history/details",
    Component: WhatsappHistoryDetails,
    rolename: "WhatsApp_History",
  },
  {
    path: "/account/analytics/cash-flow",
    Component: CashFlowDashbaord,
    rolename: "ERP-Analytics_Cash Flow",
  },
  {
    path: "/account/analytics/project-cost",
    Component: ProjectCostDashboard,
    rolename: "ERP-Analytics_Project Cost",
  },
  {
    path: "/account/analytics/sales-recovery",
    Component: SalesRecoveryDashboard,
    rolename: "ERP-Analytics_Sales Recovery",
  },
  {
    path: "/account/analytics/profitability",
    Component: ProfitabilityMarginsDashboard,
    rolename: "ERP-Analytics_Profitability",
  },
  {
    path: "/account/analytics/executive-overview",
    Component: ExecutiveOverviewDashboard,
    rolename: "ERP-Analytics_Executive Overview",
  },
];
